module.exports = __webpack_public_path__ + "static/29-00152e74ad193cabfd446cba0740a1bb.png";